import type { TypographyProps } from '@cobliteam/ui/components/Typography';
import { cn } from '@cobliteam/ui/utils';
import React from 'react';

type TextVariant = TypographyProps['variant'];

export interface SummaryContext {
  isLoading: boolean;
  textVariant: TextVariant;
}

const SummaryContext = React.createContext<SummaryContext>({ isLoading: false, textVariant: 'text-md' });

export interface SummaryVehicleMediaProps {
  className?: string;
  isLoading?: boolean;
  textVariant?: TextVariant;
}

const SummaryVehicleMedia = ({ children, className, isLoading = false, textVariant = 'text-md' }: React.PropsWithChildren<SummaryVehicleMediaProps>) => {
  return (
    <SummaryContext.Provider value={{ isLoading, textVariant }}>
      <div className={cn('flex flex-wrap items-center gap-x-6 gap-y-3', className)}>{children}</div>
    </SummaryContext.Provider>
  );
};

export function useSummary() {
  const context = React.useContext(SummaryContext);
  if (!context) {
    throw new Error('useSummary must be used within an SummaryVehicleMedia');
  }
  return context;
}

export default SummaryVehicleMedia;
